import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/vehicleInventorySettingValues'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class vehicleInventorySettingValuesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "vehicleInventorySettingValuesStore",
			variables: false,
		})
	}
}

export async function load_vehicleInventorySettingValues(params) {
  await initClient()

	const store = new vehicleInventorySettingValuesStore()

	await store.fetch(params)

	return {
		vehicleInventorySettingValues: store,
	}
}
